import apiService from '@/services/apiService';

const actions = {
  getShortenURLData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('shortening-url/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createShortenURL({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('shortening-url', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateShortenURL({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`shortening-url/${payload.unique_code}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteShortenURL({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.delete(`shortening-url/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;